import React, { useState, useEffect } from "react";
import "./TemplateModal.css";
import { useLanguage } from "../../contexts/language/LanguageContext";
import { buildApiUrl } from "../../config/env";

export default function TemplateModal({ open, onClose, onSubmit }) {
  const [templates, setTemplates] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [enableBatchName, setEnableBatchName] = useState(false);
  const [batchName, setBatchName] = useState("");

  const { t } = useLanguage();

  // Fetch API khi mở popup
  useEffect(() => {
    if (open) {
      fetch(buildApiUrl("packages/"))
        .then((res) => res.json())
        .then((data) => setTemplates(data))
        .catch((err) => console.log("Error fetch templates:", err));
    }
  }, [open]);

  if (!open) return null;

  // Lấy template được chọn
  const chosenTemplate = templates.find((t) => t._id === selectedId);

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3 className="modal-title">{t("pkg_modal_title")}</h3>

        {/* Dropdown 1: Phân loại tài liệu */}
        <div className="form-group">
          <label>{t("pkg_label_type")}</label>

          <select
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
          >
            <option value="">{t("pkg_opt_select_type")}</option>

            {templates.map((t) => (
              <option key={t._id} value={t._id}>
                {t.name}
              </option>
            ))}
          </select>
        </div>

        {/* Dropdown 2: Danh sách mẫu (sample) */}
        <div className="form-group">
          <label>{t("pkg_label_sample")}:</label>

          <select disabled={!selectedId}>
            {!selectedId && <option>{t("pkg_opt_no_type")}</option>}
            {selectedId && <option>{chosenTemplate?.sample}</option>}
          </select>
        </div>

        {/* Checkbox + batch name */}
        <div className="form-group checkbox-row">
          <input
            type="checkbox"
            checked={enableBatchName}
            onChange={() => setEnableBatchName(!enableBatchName)}
          />
          <label>{t("pkg_check_batch_name")}</label>
        </div>

        {enableBatchName && (
          <input
            className="text-input"
            placeholder={t("pkg_ph_batch_name")}
            value={batchName}
            onChange={(e) => setBatchName(e.target.value)}
          />
        )}

        {/* Buttons */}
        <div className="modal-actions">
          <button
            className="btn-primary"
            onClick={() => {
              if (!selectedId) return;

              onSubmit({
                templateId: selectedId, // giữ lại _id
                name: chosenTemplate.name,
                sample: chosenTemplate.sample,
                batchName,
              });
              onClose();
            }}
          >
            {t("pkg_btn_select")}
          </button>

          <button className="btn-secondary" onClick={onClose}>
            {t("pkg_btn_cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
